import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Input,
  Select,
  useToast,
  FormControl,
  FormLabel,
  Switch,
  Tooltip,
} from '@chakra-ui/react';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import { EditIcon, AddIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import EditModal from './editModal';
import { usePermissions } from 'contexts/PermissionContext';
// Custom components
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import OperationLocationAPI from '../../../../api/operationlocation';
import { Modules } from 'config/constant';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';

export default function TableData(props) {
  const { secondary } = props;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  // const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [booleanFilter, setBooleanFilter] = useState('');
  const [isactive, setisactive] = useState();
  const { getPermissionsForModule } = usePermissions();
  const [operationLocationPermissions, setOperationLocationPermissions] =
    useState(null);
  const [fetchListError, setFetchListError] = useState(false);

  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (e.g., 800ms)
  };
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  const fetchList = async () => {
    try {
      setLoading(true);
      let response = await OperationLocationAPI.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
        booleanFilter,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const operationLocationPermissions = getPermissionsForModule([
      Modules.OperationLocation,
    ]);
    setOperationLocationPermissions(operationLocationPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (operationLocationPermissions?.read) {
      fetchList();
    }
  }, [currentPage, searchTerm, booleanFilter, operationLocationPermissions]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, booleanFilter]);

  console.log('permidssion', operationLocationPermissions);

  //  If user doesn't have read permissions, show a message and exit early
  if (!operationLocationPermissions?.read) {
    return <NoPermissionsMessage module={Modules.OperationLocation} />;
  }

  return (
    <Flex
      height='100%'
      mt='8rem'
      direction='column'>
      {fetchListError ? (
        <PageError />
      ) : (
        <>
          <Flex
            direction={{ sm: 'column', md: 'row' }}
            px={5}
            mb='20px'
            width='100%'
            gap={10}>
            <Flex>
              <Input
                variant='auth'
                type='text'
                placeholder='Search location..'
                onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
              />
            </Flex>
            <Flex>
              <FormControl
                display='flex'
                alignItems='center'>
                <FormLabel
                  htmlFor='status-filter'
                  mb='0'>
                  Status
                </FormLabel>
                <Select
                  id='status-filter'
                  value={booleanFilter}
                  onChange={(e) => setBooleanFilter(e.target.value)}>
                  <option value=''>All</option>
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </Select>
              </FormControl>
            </Flex>
            <Flex ml='auto'>
              <Tooltip
                label={
                  !operationLocationPermissions.create
                    ? 'You do not have permission to add new locations'
                    : undefined
                }
                placement='top'
                shouldWrapChildren>
                <AddModal
                  Icon={<AddIcon />}
                  head={'Add New Operation Location'}
                  func={fetchList}
                  disabled={
                    !operationLocationPermissions.read ||
                    !operationLocationPermissions.create
                  }
                />
              </Tooltip>
            </Flex>
          </Flex>

          <TableWrapper
            list={list}
            loading={loading}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            listTotal={listTotal}
            itemsPerPage={itemsPerPage}
            isError={isError}>
            <Table
              variant='striped'
              color='gray.500'
              mb='24px'>
              <Thead>
                <Tr>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'>
                      Sr.no
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'>
                      Name
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'>
                      Display Order
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'>
                      Status
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'>
                      Last Updated
                    </Flex>
                  </Th>
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.400'>
                      Actions
                    </Flex>
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {list?.map((obj, index) => {
                  return (
                    <Tr key={obj.id}>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {(currentPage - 1) * 10 + (index + 1)}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.name}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {obj.display_order}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Text
                          size='sm'
                          fontWeight='700'
                          color={
                            obj.is_active === true ? 'green' : { textColor }
                          }>
                          {obj.is_active === true ? 'ACTIVE' : 'INACTIVE'}
                        </Text>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {moment(obj.updated_at).format('DD MMM YY, HH:mm')}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        <Flex align='center'>
                          {console.log(
                            'edit',
                            operationLocationPermissions.update
                          )}
                          <Tooltip
                            label={
                              !operationLocationPermissions.update
                                ? 'You do not have permission to edit'
                                : undefined
                            }
                            placement='top'
                            shouldWrapChildren>
                            <span>
                              <EditModal
                                Icon={<EditIcon />}
                                head={'Edit Operation Location'}
                                name={
                                  <Input
                                    variant='auth'
                                    type='text'
                                    name='name'
                                    defaultValue={obj.name}
                                    onChange={(e) => setName(e.target.value)}
                                  />
                                }
                                displayOrder={
                                  <Input
                                    variant='auth'
                                    type='number'
                                    defaultValue={obj.display_order}
                                    onChange={(e) =>
                                      setDisplayOrder(e.target.value)
                                    }
                                  />
                                }
                                isActive={
                                  <Switch
                                    value={isactive}
                                    defaultChecked={obj.is_active}
                                    onChange={(e) =>
                                      setisactive(e.target.checked)
                                    }
                                  />
                                }
                                initialData={obj}
                                id={obj.id}
                                handleUpdate={fetchList}
                                error={error}
                                disabled={
                                  !operationLocationPermissions.read ||
                                  !operationLocationPermissions.create
                                }
                              />
                            </span>
                          </Tooltip>
                        </Flex>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableWrapper>
        </>
      )}
    </Flex>
  );
}
